var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.996,
    viewBox: "0 0 18 17.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "xmark-large-solid",
    d: "M15.729,32.4a1.287,1.287,0,1,1,1.819,1.819l-6.8,6.8,6.8,6.8a1.287,1.287,0,1,1-1.819,1.819l-6.8-6.8-6.8,6.8A1.287,1.287,0,0,1,.3,47.821l6.8-6.8-6.8-6.8A1.285,1.285,0,1,1,2.125,32.4l6.8,6.8Z",
    transform: "translate(0.075 -32.025)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.510085060c0e906c0d50b1cefc414cae.svg";
export { ForwardRef as ReactComponent };